(() => {
  let topPosition = '30%';

  if (window.innerWidth < 767) {
    topPosition = '130';
  }

  document.addEventListener("DOMContentLoaded", () => {
    const init = () => {
      const stepWrapper = document.querySelector('[js-shipping-information-section] .step-inner-wrapper');
      const steps = gsap.utils.toArray("[js-cs-step]");
      const animationTarget = document.querySelector("#animationWindow");

      console.log("Initializing animations...");

      // Check if all required elements are available
      if (!stepWrapper) {
        console.error("stepWrapper not found");
        return;
      }
      if (steps.length === 0) {
        console.error("Steps not found");
        return;
      }
      if (!animationTarget) {
        console.error("Animation target not found");
        return;
      }

      console.log("All elements found. Proceeding with initialization...");

      // Initialize GSAP animations
      gsap.to(steps, {
        yPercent: -100 * (steps.length - 1),
        ease: "none",
        scrollTrigger: {
          trigger: '[js-shipping-information-section]',
          start: `top ${topPosition}`,
          end: () => "+=" + stepWrapper.offsetHeight + 1, // Match scrollable height
          scrub: true,
          pin: true, // Retain pinning if necessary
          anticipatePin: 1, // Smooth out the transition
        },
      });

      console.log("GSAP animation initialized.");

      // Initialize Lottie animations
      LottieScrollTrigger({
        target: animationTarget,
        path: "//duschbrocken.de/cdn/shop/t/752/assets/box-lottie.json?v=167212199115821455171791968388",
        speed: "slow", // Adjust speed
        scrub: true,
        end: () => "+=" + stepWrapper.offsetHeight + 1, // Align Lottie with text scrolling
      });
    };

    // Run initialization
    init();

    // Listen for dynamic content load or resize events
    window.addEventListener("resize", () => {
      console.log("Window resized. Refreshing ScrollTrigger...");
      ScrollTrigger.refresh();
    });
  });

  function LottieScrollTrigger(vars) {
    console.log("Initializing Lottie animation...");

    let playhead = { frame: vars.startFrameOffset || 0 },
      target = gsap.utils.toArray(vars.target)[0], // Ensure we grab the right DOM element
      stepWrapper = document.querySelector('[js-shipping-information-section] .step-inner-wrapper'),
      st = {
        trigger: '[js-shipping-information-section]',
        pin: false,
        start: `top ${topPosition}`,
        end: vars.end || (() => "+=" + (stepWrapper?.offsetHeight || 0)), // Match scrolling height
        scrub: true, // Smooth scrolling
      },
      ctx = gsap.context && gsap.context(),
      animation,
      frameAnimation;

    if (!target) {
      console.error("Lottie animation target not found");
      return;
    }

    console.log("Lottie animation target found:", target);

    // Initialize Lottie Animation
    animation = lottie.loadAnimation({
      container: target,
      renderer: vars.renderer || "svg",
      loop: false,
      autoplay: false,
      path: vars.path, // Ensure this path is correct
      rendererSettings: vars.rendererSettings || {
        preserveAspectRatio: "xMidYMid slice",
      }
    });

    animation.addEventListener("data_ready", function () {
      console.log("Lottie animation data loaded successfully.");
    });

    animation.addEventListener("data_failed", function () {
      console.error("Failed to load Lottie animation data from path:", vars.path);
    });

    frameAnimation = gsap.timeline({
      scrollTrigger: st,
    });

    animation.addEventListener("DOMLoaded", function () {
      console.log("Lottie DOM loaded.");

      frameAnimation.to(playhead, {
        frame: animation.totalFrames - 1,
        ease: "none",
        duration: stepWrapper.offsetHeight / 1000, // Slow down based on content height
        onUpdate: () => {
          animation.goToAndStop(playhead.frame, true);
        },
      });

      console.log("Refreshing ScrollTrigger...");
      ScrollTrigger.refresh();
    });

    animation.frameAnimation = frameAnimation;
    return animation;
  }
})();
